import type Widget from 'views/logic/widgets/Widget';
import type { WidgetActionType } from 'views/components/widgets/Types';
import EventsWidget from 'views/logic/widgets/events/EventsWidget';
import ExportOverviewWidgetsActionComponent from 'search/ExportWidgetAction/ExportOverviewWidgetsActionComponent';

const ExportEventsOverviewWidgetAction: WidgetActionType = {
  type: 'export-events-overview-widget-action',
  position: 'menu',
  isHidden: (w: Widget) => w.type !== EventsWidget.type,
  component: ExportOverviewWidgetsActionComponent,
};

export default ExportEventsOverviewWidgetAction;
